module.exports = __webpack_public_path__ + "static/hotmart-7504d48e65bcce914cafeb57faefbd6c.png";